var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooksCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 5L15 27.5H42.5L28.75 5ZM28.75 14.6L33.575 22.5H23.9L28.75 14.6ZM42.5 32.5C36.275 32.5 31.25 37.525 31.25 43.75C31.25 49.975 36.275 55 42.5 55C48.725 55 53.75 49.975 53.75 43.75C53.75 37.525 48.725 32.5 42.5 32.5ZM42.5 50C39.05 50 36.25 47.2 36.25 43.75C36.25 40.3 39.05 37.5 42.5 37.5C45.95 37.5 48.75 40.3 48.75 43.75C48.75 47.2 45.95 50 42.5 50ZM6.25 53.75H26.25V33.75H6.25V53.75ZM11.25 38.75H21.25V48.75H11.25V38.75Z",
    fill: "#718096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksCategory);
export default __webpack_public_path__ + "static/media/BooksCategory.832dca599a9d96c570d7daf58d96c2be.svg";
export { ForwardRef as ReactComponent };